<template>
	<div>
		<Loading v-if="loading" />
		<div class="action-list">
			<div class="filter-box">
				<h5>فیلترها</h5>
				<div class="inputs-container">
					<ComponentInput ref="mobileInput" inputType="text" label="شماره موبایل:"
						@textChange="handleTextChange" />
					<ComponentInput ref="mobileInput" inputType="text" label="کد ملی:" @textChange="handleCodeChange" />
					<div class="date-filter">
						<label for="html">تاریخ :</label>
						<input id="date" type="text" class="custom-input inputs" />
						<date-picker v-model="rangeDate" range clearable format="YYYY-MM-DDTHH:mm:00"
							display-format="jMMMM jD" custom-input="#date" />
					</div>

					<CustomSelect :label="'شغل:'" :options="jobOptions" :nameFeild="'name_fa'"
						@selectChange="handleJobSelectChange" class="mr-2" />
				</div>
				<div class="d-flex justify-content-end w-100">
					<PrimaryButton :backgroundColor="'#C64925'" @click="getData">تایید</PrimaryButton>
					<PrimaryButton :backgroundColor="'#fff'" :textColor="'#C64925'" class="mr-2" @click="removeFilter">
						حذف فیلتر</PrimaryButton>
				</div>
			</div>
			<div class="box">
				<pagination v-model="page" :per-page="20" :records="totalDataCount" @paginate="myCallback" />
				<Tableview :hover="true" :bordered="true"
					:showNoContent="bankCreditChargeList && !bankCreditChargeList.length">
					<template #TableTitle>
						<tr>
							<th>ردیف</th>
							<th>شماره موبایل</th>
							<th>کد ملی</th>
							<th>نام و نام خانوادگی</th>
							<th>فروشگاه</th>
							<th>مبلغ وام درخواستی</th>
							<th>شناسه درخواست</th>
							<th>تاریخ ایجاد پرونده</th>
							<th>دلیل دریافتی</th>
							<th>وضعیت پرونده</th>
							<th>پشتیبان</th>
							<th>تاریخچه</th>
							<th>تماس</th>
							<th>عملیات</th>
							<th>بروزرسانی</th>
							<th></th>
							<th>زمان انتظار</th>

						</tr>
					</template>

					<template #TableBody>
						<tr v-for="(item, index) in bankCreditChargeList" :key="item.id" :class="{ 'selected-row': item.id === selectedID }">
							<td class="persian-number">
								{{ 20 * (page - 1) + 1 + index }}
							</td>
							<td class="persian-number">{{ item.gb_user.user.username }}</td>
							<td class="persian-number">
								{{ item.gb_user.national_code }}
							</td>
							<td>{{ item.gb_user.first_name }} {{ item.gb_user.last_name }}</td>
							<td>
								<span v-if="item.store" @click="storeHandler(item)" class="store-link">{{ item.store }}</span>
								<span v-else>-</span>
							</td>
							<td class="persian-number">
								{{ item.loan_payment_plan.loan_plan.amount_separate }} ریال
							</td>
							<td class="persian-number">
								{{ item.loan_cases && item.loan_cases[0] ? item.loan_cases[0].loan_request : '-' }}
							</td>
							<td>
								<date-picker v-if="item.loan_cases && item.loan_cases[0]"
									v-model="item.loan_cases[0].date_time_create" type="datetime" format="YYYY-MM-DD"
									display-format="jYYYY-jMM-jDD" :timezone="true" :disabled="true" />
								<span v-else>-</span>
							</td>
							<td>
								<span v-if="item.loan_cases && item.reason">
									<span>
										{{ getShortReason(item) }}
										<span v-if="item.reason.length > 90" class="show-more" @click="showFullReason(item.reason)">...</span>
									</span>
								</span>
								<span v-else>-</span>
							</td>
							<td>
								{{ item.loan_status.verbose_name }}
							</td>
							<td>
								{{ item.call_center_gb_user ? item.call_center_gb_user.first_name || '-' : '-' }}
								{{ item.call_center_gb_user ? item.call_center_gb_user.last_name || '-' : '-' }}
							</td>
							<td>
								<button class="comment-history-btn" @click="showCommentHistory(item)">نمایش کامنت‌ها</button>
							</td>
							<td>
								<img @click="callHandler(item)" src="../../assets/images/call-ringing.svg"
									:class="getCallClass(item)" alt="Call Status" />
							</td>
							<td>
								<img style="cursor: pointer;" @click="moreInfoHandler(item)"
									src="../../assets/images/iconPack/user_data_admin.svg" />
							</td>
							<td>
								<img style="cursor: pointer;" @click="blueUpdateStatus(item.id)"
									src="../../assets/images/iconPack/refresh-white-orange.svg" />
							</td>
							<td>
								<img style="cursor: pointer;" @click="openBlockUserModal(item)"
									src="../../assets/images/iconPack/lock.svg" class="icon-red" />
							</td>
							<td>
								<dateUtils :date="item.date_time_blu_last_push" emptyText="-" />
							</td>
						</tr>
					</template>
				</Tableview>
				<b-modal v-model="blockUserModal" hide-footer hide-header centered>
					<div class="px-4">
						<h5 class="mb-3">
							مسدود کردن کاربر
							<span v-if="selectedBlockItem"> - {{ selectedBlockItem.gb_user.first_name }} {{ selectedBlockItem.gb_user.last_name }}</span>
						</h5>
						<p class="mb-3">دلیل مسدود کردن را انتخاب کنید</p>
						<p class="mb-2"><strong>دلیل انتخاب‌شده:</strong> لغو وام به درخواست کاربر</p>
						<div class="d-flex justify-content-end mt-3" style="gap: 8px">
							<PrimaryButton :backgroundColor="'#fff'" :textColor="'#C64925'" class="mr-2"
								@click="blockUserModal = false">
								منصرف شدم
							</PrimaryButton>
							<PrimaryButton :backgroundColor="'#C64925'" @click="confirmBlockUser">
								تایید
							</PrimaryButton>
						</div>
					</div>
				</b-modal>
				<b-modal v-model="moreInfoModal" hide-footer hide-header centered size="xl">
					<div class="px-4">
						<div class="loan-info-form">
							<h6 class="mb-3">اطلاعات کاربر</h6>
							<div class="form-row">
								<div class="form-group col-md-4">
									<label>نام:</label>
									<p>{{ selectedGBUser ? selectedGBUser.first_name : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>نام خانوادگی:</label>
									<p>{{ selectedGBUser ? selectedGBUser.last_name : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>کد ملی:</label>
									<p>{{ selectedGBUser ? selectedGBUser.national_code : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>تاریخ تولد:</label>
									<p>{{ selectedGBUser ? selectedGBUser.birth_date_fa : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>شغل:</label>
									<p>{{ selectedGBUser ? selectedGBUser.job : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>سمت شغلی:</label>
									<p>{{ selectedGBUser ? selectedGBUser.job_role : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>کد پستی:</label>
									<p>{{ selectedGBUser ? selectedGBUser.postal_code : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>نوع مالکیت منزل:</label>
									<p>{{ selectedGBUser ? selectedGBUser.house_ownership : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>میانگین درآمد:</label>
									<p>
										{{
											selectedGBUser
												? Number(selectedGBUser.income_avg).toLocaleString('fa-IR')
												: '-'
										}}
										ریال
									</p>
								</div>
								<div class="form-group col-md-4">
									<label>میانگین هزینه:</label>
									<p>
										{{
											selectedGBUser ? Number(selectedGBUser.cost_avg).toLocaleString('fa-IR') : '-'
										}}
										ریال
									</p>
								</div>
								<div class="form-group col-md-4">
									<label>قسط ماهیانه:</label>
									<p>
										{{
											selectedGBUser
												? Number(selectedGBUser.monthly_instalment).toLocaleString('fa-IR')
												: '-'
										}}
										ریال
									</p>
								</div>

							</div>

							<!-- Basic Information -->
							<h6 class="mb-3">اطلاعات پایه</h6>
							<div class="form-row">
								<div class="form-group col-md-4">
									<label>شناسه پرونده:</label>
									<p>{{ selectedLoanCase ? selectedLoanCase.id_persian : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>شماره درخواست:</label>
									<p>{{ selectedLoanCase ? selectedLoanCase.loan_request_persian : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>تاریخ ایجاد:</label>
									<p>{{ selectedLoanCase ? selectedLoanCase.date_time_create_fa : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>وضعیت پرونده:</label>
									<p>{{ selectedLoanCase ? selectedLoanCase.case_status : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>شماره چک:</label>
									<p>{{ selectedLoanCase ? selectedLoanCase.cheque_number : '-' }}</p>
								</div>
								<div class="form-group col-md-4">
									<label>شماره سریال چک:</label>
									<p>{{ selectedLoanCase ? selectedLoanCase.check_serial_number : '-' }}</p>
								</div>
							</div>



							<!-- Documents -->
							<div class="documents-section mt-4">
								<h6 class="mb-3">مدارک</h6>
								<div class="document-links">
									<div class="form-row">
										<div class="col-md-4" v-if="selectedLoanCase && selectedLoanCase.contract_link">
											<div class="document-card">
												<!-- <img src="../../assets/images/iconPack/document.svg" alt="قرارداد" class="doc-icon"> -->
												<a :href="selectedLoanCase.contract_link" target="_blank"
													class="doc-link">
													<span>دانلود قرارداد</span>
												</a>
											</div>
										</div>
										<div class="col-md-4"
											v-if="selectedLoanCase && selectedLoanCase.check_image_link">
											<div class="document-card">
												<!-- <img src="../../assets/images/iconPack/document.svg" alt="تصویر چک" class="doc-icon"> -->
												<a :href="selectedLoanCase.check_image_link" target="_blank"
													class="doc-link">
													<span>دانلود تصویر چک</span>
												</a>
											</div>
										</div>
										<div class="col-md-4"
											v-if="selectedLoanCase && selectedLoanCase.income_account_print_link">
											<div class="document-card">
												<!-- <img src="../../assets/images/iconPack/document.svg" alt="تصویر چک" class="doc-icon"> -->
												<a :href="selectedLoanCase.income_account_print_link" target="_blank"
													class="doc-link">
													<span>دانلود صورت حساب</span>
												</a>
											</div>
										</div>
										<div class="col-md-4"
											v-if="selectedLoanCase && selectedLoanCase.income_cheque_link">
											<div class="document-card">
												<!-- <img src="../../assets/images/iconPack/document.svg" alt="تصویر چک" class="doc-icon"> -->
												<a :href="selectedLoanCase.income_cheque_link" target="_blank"
													class="doc-link">
													<span>دانلود مدرک شغلی/فیش حقوقی</span>
												</a>
											</div>
										</div>
										<div class="col-md-4"
											v-if="selectedLoanCase && selectedLoanCase.occupation_proof_link">
											<div class="document-card">
												<!-- <img src="../../assets/images/iconPack/document.svg" alt="گواهی شغلی" class="doc-icon"> -->
												<a :href="selectedLoanCase.occupation_proof_link" target="_blank"
													class="doc-link">
													<span>دانلود گواهی شغلی</span>
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</b-modal>
				<b-modal v-model="editLoanModal" hide-footer hide-header centered size="xl">
					<div class="px-4">
						<h5 class="mb-4">ویرایش پرونده</h5>
						<div class="edit-form">
							<div class="form-row">
								<div class="form-group col-md-4" v-for="field in editableFields" :key="field.value">
									<div class="d-flex align-items-center mb-2">
										<input type="checkbox" :value="field.value" v-model="selectedFields"
											class="mr-2" />
										<label>{{ field.label }}</label>
									</div>
								</div>
							</div>

							<CustomSelect :label="'وضعیت:'" :options="stateOptions" :nameFeild="'label'"
								@selectChange="handleStateChange" />
							<div class="form-group mt-3 w-50">
								<label class="mb-2">دلیل:</label>
								<vue-editor v-model="correctionReason" placeholder="در این قسمت دلیل خود را وارد کنید"
									:editorOptions="editorOptions" class="rtl-editor" />
							</div>

							<div class="d-flex justify-content-end mt-4">
								<PrimaryButton :backgroundColor="'#C64925'" @click="submitCorrections"
									:loading="submitEditloading" :disabled="disabledSubmit">
									ثبت اصلاحات
								</PrimaryButton>
								<PrimaryButton :backgroundColor="'#fff'" :textColor="'#C64925'" class="mr-2"
									@click="cancelEdit">
									بستن
								</PrimaryButton>
							</div>
						</div>
					</div>
				</b-modal>
				<b-modal v-model="callModal" hide-footer hide-header centered size="xl">
					<div class="px-4" v-if="item">
						<div class="loan-info-form">
							<h6 class="mb-3">وضعیت تماس</h6>
							<div class="form-row">
								<div class="form-group col-md-4">
									<label>تماس اول:</label>
									<div class="custom-checkbox">
										<input type="checkbox" v-model="backOfficeCall1" />
										<span class="checkmark"></span>
									</div>
								</div>
								<div class="form-group col-md-4">
									<label>تماس دوم:</label>
									<div class="custom-checkbox">
										<input type="checkbox" v-model="backOfficeCall2" />
										<span class="checkmark"></span>
									</div>
								</div>
								<div class="form-group col-md-4">
									<label>نتیجه تماس:</label>
									<textarea v-model="backOfficeComment" class="form-control"></textarea>
								</div>
							</div>
							<div class="d-flex justify-content-end mt-3">
								<PrimaryButton :backgroundColor="'#C64925'" @click="updateBackOfficeFields">
									ثبت تغییرات
								</PrimaryButton>
							</div>
						</div>
					</div>
				</b-modal>
				<b-modal v-model="fullReasonModal" hide-footer hide-header centered>
					<div class="px-4">
						<h5 class="mb-3">دلیل کامل</h5>
						<div style="white-space: pre-line;">{{ fullReasonText }}</div>
						<div class="d-flex justify-content-end mt-3">
							<PrimaryButton :backgroundColor="'#C64925'" @click="fullReasonModal = false">
								بستن
							</PrimaryButton>
						</div>
					</div>
				</b-modal>
				<b-modal v-model="commentHistoryModal" hide-footer hide-header centered>
					<div class="px-4">
						<h5 class="mb-3">تاریخچه کامنت‌ها</h5>
						<div v-if="selectedComments.length">
							<div v-for="(comment, idx) in selectedComments" :key="idx" class="mb-3">
								<div><strong>تامین کننده:</strong> {{ comment.provider }}</div>
								<div><strong>متن کامنت:</strong> {{ comment.comment }}</div>
								<hr v-if="idx !== selectedComments.length - 1" />
							</div>
						</div>
						<div v-else>
							<span>کامنتی وجود ندارد.</span>
						</div>
						<div class="d-flex justify-content-end mt-3">
							<PrimaryButton :backgroundColor="'#C64925'" @click="commentHistoryModal = false">
								بستن
							</PrimaryButton>
						</div>
					</div>
				</b-modal>
				<b-modal v-model="storeModal" hide-footer hide-header centered>
					<div class="px-4">
						<h5 class="mb-3">اطلاعات فروشگاه</h5>
						<div style="white-space: pre-line;">{{ storeOwnerName }}</div>
						<div style="white-space: pre-line;">{{ storeMobileNumber }}</div>
						<div class="d-flex justify-content-end mt-3">
							<PrimaryButton :backgroundColor="'#C64925'" @click="storeModal = false">
								بستن
							</PrimaryButton>
						</div>
					</div>
				</b-modal>

				<!-- <div class="d-flex justify-content-end">
			<button @click="confirmItems" class="confirm-item">ثبت نهایی</button>
		</div> -->
			</div>
		</div>
	</div>
</template>

<script>
import Tableview from '../../components/Tableview/index.vue';
import Pagination from 'vue-pagination-2';
// import CustomInput from '../../components/InputFilter/customInput.vue';
import CustomSelect from '../../components/InputFilter/customSelect.vue';
import PrimaryButton from '../../components/Button/Btn.vue';
import Loading from '../../components/Loading/index.vue';
import ComponentInput from '../../components/InputFilter/customInput.vue';
import { VueEditor } from 'vue2-editor';
import dateUtils from '../../components/DateTime/dateUtils.vue';

export default {
	components: {
		Tableview,
		Pagination,
		Loading,
		ComponentInput,
		CustomSelect,
		PrimaryButton,
		VueEditor,
		dateUtils,
	},
	data() {
		return {
			bankCreditChargeList: [],
			totalDataCount: 0,
			page: 1,
			loading: true,
			selectCityOptions: [],
			selectedCityOption: '',
			selectedProvinceOption: '',
			selectProvinceOptions: [],
			computedMobileNumber: '',
			computedNationalCode: '',
			rangeDate: ['', ''],
			selectedState: '',
			jobOptions: [
				{
					id: 'retired',
					name: 'retired',
					name_fa: 'بازنشسته',
				},
				{
					id: 'employee',
					name: 'employee',
					name_fa: 'کارمند',
				},
				{
					id: 'employer/freelancer',
					name: 'employer/freelancer',
					name_fa: 'آزاد',
				},
			],
			selectedCaseStatusOption: '',
			selectedJobOption: '',
			moreInfoModal: false,
			callModal: false,
			editLoanModal: false,
			payableState: null,
			ids: null,
			selectedLoanCase: null,
			selectedGBUser: null,
			caseStatus: [],
			selectedFields: [],
			correctionReason: '',
			editableFields: [
				// { value: 'national_identifier', label: 'کد ملی' },
				{ value: 'birth_date', label: 'تاریخ تولد' },
				// { value: 'residence_address.province', label: 'استان' },
				// { value: 'residence_address.city', label: 'شهر' },
				{ value: 'residence_address.address', label: 'آدرس' },
				{ value: 'residence_address.postal_code', label: 'کد پستی' },
				{ value: 'residency_type', label: 'نوع سکونت' },
				{ value: 'home_phone_number', label: 'تلفن ثابت' },
				{ value: 'income_amount', label: 'میزان درآمد' },
				{ value: 'occupation_type', label: 'نوع شغل' },
				{ value: 'occupation_title', label: 'عنوان شغل' },
				{ value: 'monthly_cost', label: 'هزینه ماهیانه' },
				{ value: 'monthly_installments', label: 'اقساط ماهیانه' },
				{ value: 'income_account_print', label: 'تصویر صورت حساب' },
				{ value: 'income_cheque', label: 'تصویر فیش حقوقی' },
				{ value: 'occupation_proof', label: 'تصویر سایر مدارک' },
			],
			stateOptions: [
				{ id: 'user_need_correction', label: 'نیاز به اصلاح اطلاعات' },
				{ id: 'blocked', label: 'مسدود کردن' },
				// { id: 'admin_confirmed', label: 'تایید ' },
			],
			submitEditloading: false,
			acceptLoanLoading: false,
			editorOptions: {

				placeholder: 'در این قسمت دلیل خود را وارد کنید',
				direction: 'rtl'
			},
			backOfficeCall1: false,
			backOfficeCall2: false,
			backOfficeComment: '',
			fullReasonModal: false,
			fullReasonText: '',
			selectedComments: [],
			commentHistoryModal: false,
			blockUserModal: false,
			selectedBlockItem: null,
			selectedBlockReasonId: '',
			selectedID: null,
			BackOfficeCommentList: [],
			storeModal: false,
			storeOwnerName: null,
			storeMobileNumber:null,

		};
	},
	computed: {
		disabledSubmit() {
			if (this.selectedState === 'blocked' && this.correctionReason !== '') {
				return false;
			}

			if (this.selectedFields.length === 0) {
				return true;
			}
			if (this.correctionReason === '') {
				return true;
			}
			return false;
		},
	},
	mounted() {
		this.getData();
		this.getCaseStatus();
		this.getBackOfficeComment();
	},
	methods: {
		async getBackOfficeComment() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.BackOfficeComment,
				'',
				{},
			);
			if (res.status === 200) {
				this.BackOfficeCommentList = res.data;
			}
		},
		async getData(limit = 20, offset = 0) {
			if (this.rangeDate[0] !== '' && this.rangeDate[1] == undefined) {
				this.rangeDate[1] = this.rangeDate[0].slice(0, 11) + '23:59:59';
			} else if (this.rangeDate[0] === null || this.rangeDate[0] === undefined) {
				this.rangeDate[0] = '';
			}
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.REQUEST_LIST +
				'?limit=' +
				limit +
				'&offset=' +
				offset +
				'&gb_user__user__username=' +
				this.computedMobileNumber +
				'&gb_user__national_code=' +
				this.computedNationalCode +
				'&gb_user__job_role=' +
				this.selectedJobOption +
				'&loan_status__id=' +
				'10' +
				'&date_time_create__gte=' +
				this.rangeDate[0] +
				'&date_time_create__lte=' +
				this.rangeDate[1] +
				'&ordering=date_time_blu_last_push',
				'',
				{},
			);
			if (res.status === 200) {
				this.bankCreditChargeList = res.data.results;
				this.totalDataCount = res.data.count;
				this.loading = false;
			}
		},
		async getCaseStatus() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.CASE_STATUS + '?provider=3',
				this.$PATH.SERVICE_NAME.LOYALTY,
				{},
			);
			if (res.status === 200) {
				console.log(res.data);
				this.caseStatus = res.data;
			}
		},
		handleTextChange(value) {
			this.computedMobileNumber = value;
		},
		handleCodeChange(value) {
			this.computedNationalCode = value;
		},

		handleJobSelectChange(value) {
			this.selectedJobOption = value;
		},
		handleStateChange(value) {
			this.selectedState = value;
		},
		handleBlockReasonChange(value) {
			this.selectedBlockReasonId = value;
		},
		moreInfoHandler(item) {
			this.selectedLoanCase = item.loan_cases[0];
			this.selectedGBUser = item.gb_user;
			this.moreInfoModal = !this.moreInfoModal;
			this.selectedID = item.id;
		},
		openBlockUserModal(item) {
			this.selectedBlockItem = item;
			this.selectedBlockReasonId = '';
			this.selectedID = item.id;
			this.blockUserModal = true;
		},
		async confirmBlockUser() {
			const reasonText = 'لغو وام به درخواست کاربر';
			if (!this.selectedBlockItem || !this.selectedBlockItem.loan_cases || !this.selectedBlockItem.loan_cases[0]) {
				this.$notify({
					group: 'tc',
					type: 'error',
					text: 'اطلاعات پرونده نامعتبر است',
				});
				return;
			}
			const payload = {
				need_to_correct_fields: [],
				reason: reasonText,
				state: 'blocked',
			};
			try {
				const res = await this.$ApiServiceLayer.patch(
					this.$PATH.RELATIVE_PATH.MULTI.ADMIN_BLU_CALL_BACK_UPDATE_STATUS +
					this.selectedBlockItem.loan_cases[0].loan_request +
					'/',
					this.$PATH.SERVICE_NAME.LOYALTY,
					payload,
				);
				if (res.status === 200) {
					this.$notify({
						group: 'tc',
						type: 'success',
						text: 'مسدودسازی با موفقیت ثبت شد',
					});
					this.blockUserModal = false;
					this.getData();
				} else {
					this.$notify({
						group: 'tc',
						type: 'error',
						text: 'خطا در ثبت مسدودسازی',
					});
				}
			} catch (e) {
				this.$notify({
					group: 'tc',
					type: 'error',
					text: 'خطا در ثبت مسدودسازی',
				});
			}
		},
		callHandler(item) {
			this.item = item;
			this.backOfficeCall1 = item.back_office_call1;
			this.backOfficeCall2 = item.back_office_call2;
			this.backOfficeComment = item.back_office_comment || '';
			this.callModal = !this.callModal;
		},
		commentHandler(item){
			this.item = item ;
			this.commentHistory = item.comment_history[0].comment;
		},
		getDaysDiffFromNow(date) {
			if (!date) return '-';
			const now = new Date();
			const target = new Date(date);
			now.setHours(0, 0, 0, 0);
			target.setHours(0, 0, 0, 0);
			const diffMs = now - target;
			const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
			return diffDays >= 0 ? `${diffDays} روز پیش` : 'در آینده';
		},
		async blueUpdateStatus(loan_request) {
			this.loading = true;
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.AdminBluUpdateStatusViewSet + loan_request,
				this.$PATH.SERVICE_NAME.LOYALTY,
				{},
			);
			if (res.status === 428) {
				this.getData();
				this.loading = false;
			}
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'اطلاعات با موفقیت بروزرسانی شد',
				});
				console.log(res.data);
				this.getData();
				this.loading = false;
			}
		},
		removeFilter() {
			this.computedMobileNumber = '';
			this.computedNationalCode = '';
			this.selectedCaseStatusOption = '';
			this.selectedJobOption = '';
			this.rangeDate = ['', ''];
			// this.$refs.mobileInput.$emit('textChange', '');
			this.getData();
		},
		async acceptLoan() {
			this.acceptLoanLoading = true;
			const res = await this.$ApiServiceLayer.patch(
				`${this.$PATH.RELATIVE_PATH.MULTI.ADMIN_BLU_CALL_BACK_UPDATE_STATUS}${this.selectedLoanCase.loan_request}/`,
				this.$PATH.SERVICE_NAME.LOYALTY,
				{ state: 'admin_confirmed' },
			);
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'تایید با موفقیت ثبت شد',
				});
				this.moreInfoModal = false;
				this.getData();
			}
			this.acceptLoanLoading = false;
		},
		async updateBackOffice() {
			const res = await this.$ApiServiceLayer.patch(
				this.$PATH.RELATIVE_PATH.MULTI.LOAN_REQUEST_BACK_OFFICE_UPDATE +
				this.selectedLoanCase.loan_request +
				'/',
				this.$PATH.SERVICE_NAME.LOYALTY,
			);
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'درخواست اصلاح با موفقیت ثبت شد',
				});
			}
		},
		editLoan() {
			this.moreInfoModal = !this.moreInfoModal;
			this.editLoanModal = !this.editLoanModal;
		},
		rejectLoan() {
			this.moreInfoModal = !this.moreInfoModal;
		},

		async submitCorrections() {
			this.submitEditloading = true;
			// if (this.selectedFields.length === 0) {
			// 	this.$notify({
			// 		group: 'tc',
			// 		type: 'warning',
			// 		text: 'لطفا حداقل یک فیلد را انتخاب کنید',
			// 	});
			// 	return;
			// }

			const payload = {
				// loan_case_id: this.selectedLoanCase.id,
				need_to_correct_fields: this.selectedFields,
				reason: this.correctionReason,
				state: this.selectedState,
			};

			const res = await this.$ApiServiceLayer.patch(
				this.$PATH.RELATIVE_PATH.MULTI.ADMIN_BLU_CALL_BACK_UPDATE_STATUS +
				this.selectedLoanCase.loan_request +
				'/',
				this.$PATH.SERVICE_NAME.LOYALTY,
				payload,
			);

			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'درخواست اصلاح با موفقیت ثبت شد',
				});
				this.editLoanModal = false;
				this.selectedFields = [];
				this.correctionReason = '';
			}
			this.submitEditloading = false;
		},
		async myCallback() {
			await this.getData(20, 20 * (this.page - 1));
		},
		cancelEdit() {
			this.editLoanModal = false;
			this.selectedFields = [];
			this.correctionReason = '';
		},
		getCallClass(item) {
			const call1 = item.back_office_call1;
			const call2 = item.back_office_call2;
			if (call1 && call2) return 'call-green';
			if (call1 || call2) return 'call-orange';
			return 'call-gray';
		},
		async updateBackOfficeFields() {
			const payload = {
				back_office_call1: this.backOfficeCall1,
				back_office_call2: this.backOfficeCall2,
				back_office_comment: this.backOfficeComment,
			};
			const res = await this.$ApiServiceLayer.patch(
				this.$PATH.RELATIVE_PATH.MULTI.LOAN_REQUEST_BACK_OFFICE_UPDATE +
				this.item.id +
				'/',
				this.$PATH.SERVICE_NAME.LOYALTY,
				payload,
			);
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'اطلاعات تماس با موفقیت ثبت شد',
				});
				this.callModal = false;
				this.myCallback();
			}
		},
		getShortReason(item) {
			if (item.loan_cases && item.reason) {
				const text = item.reason;
				return text.length > 90 ? text.slice(0, 90) : text;
			}
			return '-';
		},
		showFullReason(reason) {
			this.fullReasonText = reason;
			this.fullReasonModal = true;
		},
		showCommentHistory(item) {
			this.selectedComments = item.comment_history || [];
			this.commentHistoryModal = true;
		},
		storeHandler(item) {
			this.storeOwnerName = item.store_owner_name;
			this.storeMobileNumber = item.store_phone_number;
			this.storeModal = true;
		},
	},
};
</script>
<style lang="scss" scoped>
.empty-container {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 80vh;
}

.action-list {
	width: 100%;
	padding: 24px;
	min-height: 80vh;

	.filter-box {
		box-shadow: 0px 0px 10px 0px rgba(214, 214, 214, 0.6);
		padding: 24px;
		border-radius: 8px;

		.inputs-container {
			display: flex;
		}

		.date-filter {
			margin-bottom: 15px;
			margin-right: 8px;

			label {
				display: block;
				margin-bottom: 5px;
			}

			.inputs {
				width: 200px;
				height: 38px;
				border: 1px solid #c4c4c4;
				padding: 0 9px;
				border-radius: 4px;
			}
		}
	}

	.box {
		margin-top: 16px;
		padding: 24px;
		border-radius: 2px;
		margin-bottom: 16px;
		background: #fff;
		border-radius: 8px;
		box-shadow: 0px 0px 10px 0px rgba(214, 214, 214, 0.6);
	}

	.persian-number {
		font-family: 'IRANYekanfa' !important;
	}

	.watch-items {
		cursor: pointer;
	}

	.action-icon {
		cursor: pointer;
		width: 32px;
	}
}

.icon-red {
	filter: brightness(0) saturate(100%) invert(25%) sepia(85%) saturate(915%) hue-rotate(346deg) brightness(95%) contrast(95%);
}

.selected-row {
	background: #fff5f2;
}

.confirm-item {
	background: none;
	padding: 8px;
	border: 1px solid #c64925;
	border-radius: 4px;
	background: #c64925;
	color: #fff;
	margin-left: 8px;
	min-width: 75px;
}

.reject-item {
	border: 1px solid #c64925;
	background: #fff;
	color: #000;
	width: 75px;
	border-radius: 4px;
	color: #c64925;
	padding: 8px;
	border-radius: 12px;
	margin-right: 8px;
}

.loan-info-form {
	.form-row {
		display: flex;
		flex-wrap: wrap;
		margin-right: -15px;
		margin-left: -15px;
	}

	.form-group {
		padding: 0 15px;
		margin-bottom: 1.5rem;

		label {
			display: block;
			font-weight: bold;
			margin-bottom: 0.5rem;
			color: #666;
			font-size: 0.9rem;
		}

		p {
			margin: 0;
			color: #333;
			font-size: 1rem;
		}
	}

	h6 {
		color: #c64925;
		font-weight: bold;
		border-bottom: 2px solid #eee;
		padding-bottom: 0.5rem;
	}

	.documents-section {
		.document-links {
			.document-card {
				border: 1px solid #eee;
				padding: 1rem;
				border-radius: 8px;
				text-align: center;
				transition: all 0.3s ease;
				margin-bottom: 16px;

				&:hover {
					box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
				}

				.doc-icon {
					width: 40px;
					height: 40px;
					margin-bottom: 0.5rem;
				}

				.doc-link {
					display: block;
					color: #c64925;
					text-decoration: none;
					font-weight: 500;

					&:hover {
						text-decoration: underline;
					}
				}
			}
		}
	}
}

// Add this if you want to make the modal wider
::v-deep .modal-xl {
	max-width: 1140px;
}

.edit-form {
	.form-group {
		margin-bottom: 1rem;

		label {
			margin-bottom: 0;
			margin-right: 0.5rem;
		}

		input[type='checkbox'] {
			width: 18px;
			height: 18px;
			cursor: pointer;
		}
	}
}

.custom-checkbox {
	position: relative;
	display: inline-block;
	width: 22px;
	height: 22px;
	margin-left: 8px;
	vertical-align: middle;

	input[type='checkbox'] {
		opacity: 0;
		width: 22px;
		height: 22px;
		margin: 0;
		cursor: pointer;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
	}

	.checkmark {
		position: absolute;
		top: 0;
		left: 0;
		width: 22px;
		height: 22px;
		border-radius: 6px;
		border: 2px solid #c64925;
		background: #fff;
		transition: background 0.2s, border-color 0.2s;
	}

	input[type='checkbox']:checked+.checkmark {
		background: #c64925;
		border-color: #c64925;
	}

	input[type='checkbox']:checked+.checkmark:after {
		content: '';
		position: absolute;
		left: 6px;
		top: 2px;
		width: 6px;
		height: 12px;
		border: solid #fff;
		border-width: 0 3px 3px 0;
		transform: rotate(45deg);
	}
}

.show-more {
	color: #c64925;
	cursor: pointer;
	font-weight: bold;
}

.comment-history-btn {
	background: #fff;
	color: #c64925;
	border: 1px solid #c64925;
	border-radius: 6px;
	padding: 0px 16px;
	font-family: 'IRANYekanfa', sans-serif;
	font-size: 0.95rem;
	cursor: pointer;
	transition: background 0.2s, color 0.2s;
	margin: 0 4px;
	outline: none;
}

.comment-history-btn:hover {
	background: #c64925;
	color: #fff;
}

.store-link {
	color: #c64925;
	cursor: pointer;
	text-decoration: underline;
}
</style>
<style>
.VuePagination__count {
	display: none;
}

.page-item.active .page-link {
	background-color: #c64925;
	border-radius: 4px;
}

.page-link {
	border: none;
	color: black;
	font-family: 'IRANYekanfa' !important;
}

.vpd-icon-btn {
	display: none !important;
}

.vpd-input-group input {
	border: none !important;
	border-radius: 0;
}

.vpd-input-group input:disabled {
	background: #fff;
	text-align: center;
	min-width: 130px;
}

/* Add these styles for RTL editor */
.rtl-editor .ql-editor {
	direction: rtl;
	text-align: right;
}

.rtl-editor .ql-container.ql-snow {
	border: 1px solid #ced4da;
	border-radius: 0.25rem;
}

.rtl-editor .ql-toolbar.ql-snow {
	border: 1px solid #ced4da;
	border-top-left-radius: 0.25rem;
	border-top-right-radius: 0.25rem;
}

.call-gray {
	cursor: pointer;
	filter: brightness(0) saturate(100%) invert(49%) sepia(0%) saturate(1901%) hue-rotate(195deg) brightness(94%) contrast(74%);
}

.call-orange {
	cursor: pointer;
	filter: brightness(0) saturate(100%) invert(83%) sepia(36%) saturate(1858%) hue-rotate(357deg) brightness(100%) contrast(106%);
}

.call-green {
	cursor: pointer;
	filter: brightness(0) saturate(100%) invert(80%) sepia(15%) saturate(5632%) hue-rotate(96deg) brightness(103%) contrast(101%)
}
</style>
